// Author Liu Cui Cui
// Date 2022-07-20 12:18:28

class SithMesTpmAxisDataTad {
constructor({
        id = null,
        tadGeometricX = '',
        tadGeometricY = '',
        tadGeometricZ = '',
        tadGeometricA = '',
        tadMachineX = '',
        tadMachineY = '',
        tadMachineZ = '',
        tadMachineA = '',
        tadLoadX = '',
        tadLoadY = '',
        tadLoadZ = '',
        tadLoadA = '',
        tadExceptionDesc = '',
        tadStartTime = '',
        tadEndTime = '',
        tadDeviceCode = '',
        tadDeviceSystemType = '',
        remark = ''}
= {}) {
    this.id = id;
    this.tadGeometricX = tadGeometricX;
    this.tadGeometricY = tadGeometricY;
    this.tadGeometricZ = tadGeometricZ;
    this.tadGeometricA = tadGeometricA;
    this.tadMachineX = tadMachineX;
    this.tadMachineY = tadMachineY;
    this.tadMachineZ = tadMachineZ;
    this.tadMachineA = tadMachineA;
    this.tadLoadX = tadLoadX;
    this.tadLoadY = tadLoadY;
    this.tadLoadZ = tadLoadZ;
    this.tadLoadA = tadLoadA;
    this.tadExceptionDesc = tadExceptionDesc;
    this.tadStartTime = tadStartTime;
    this.tadEndTime = tadEndTime;
    this.tadDeviceCode = tadDeviceCode;
    this.tadDeviceSystemType = tadDeviceSystemType;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesTpmAxisDataTad();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.tpm.sithMesTpmAxisDataTad.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'tadGeometricX',
        label: 'label.sith.tpm.sithMesTpmAxisDataTad.grid.tadGeometricX',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'tadGeometricY',
        label: 'label.sith.tpm.sithMesTpmAxisDataTad.grid.tadGeometricY',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'tadGeometricZ',
        label: 'label.sith.tpm.sithMesTpmAxisDataTad.grid.tadGeometricZ',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'tadGeometricA',
        label: 'label.sith.tpm.sithMesTpmAxisDataTad.grid.tadGeometricA',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'tadMachineX',
        label: 'label.sith.tpm.sithMesTpmAxisDataTad.grid.tadMachineX',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'tadMachineY',
        label: 'label.sith.tpm.sithMesTpmAxisDataTad.grid.tadMachineY',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'tadMachineZ',
        label: 'label.sith.tpm.sithMesTpmAxisDataTad.grid.tadMachineZ',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'tadMachineA',
        label: 'label.sith.tpm.sithMesTpmAxisDataTad.grid.tadMachineA',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'tadLoadX',
        label: 'label.sith.tpm.sithMesTpmAxisDataTad.grid.tadLoadX',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'tadLoadY',
        label: 'label.sith.tpm.sithMesTpmAxisDataTad.grid.tadLoadY',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'tadLoadZ',
        label: 'label.sith.tpm.sithMesTpmAxisDataTad.grid.tadLoadZ',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'tadLoadA',
        label: 'label.sith.tpm.sithMesTpmAxisDataTad.grid.tadLoadA',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'tadExceptionDesc',
        label: 'label.sith.tpm.sithMesTpmAxisDataTad.grid.tadExceptionDesc',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'tadStartTime',
        label: 'label.sith.tpm.sithMesTpmAxisDataTad.grid.tadStartTime',
        sortable: true,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'tadEndTime',
        label: 'label.sith.tpm.sithMesTpmAxisDataTad.grid.tadEndTime',
        sortable: true,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'tadDeviceCode',
        label: 'label.sith.tpm.sithMesTpmAxisDataTad.grid.tadDeviceCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'tadDeviceSystemType',
        label: 'label.sith.tpm.sithMesTpmAxisDataTad.grid.tadDeviceSystemType',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.tpm.sithMesTpmAxisDataTad.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    tadGeometricXFilter : '',
    tadGeometricYFilter : '',
    tadGeometricZFilter : '',
    tadGeometricAFilter : '',
    tadMachineXFilter : '',
    tadMachineYFilter : '',
    tadMachineZFilter : '',
    tadMachineAFilter : '',
    tadLoadXFilter : '',
    tadLoadYFilter : '',
    tadLoadZFilter : '',
    tadLoadAFilter : '',
    tadExceptionDescFilter : '',
    tadStartTimeRteFilter : '',
    tadStartTimeLteFilter : '',
    tadEndTimeRteFilter : '',
    tadEndTimeLteFilter : '',
    tadDeviceCodeFilter : '',
    tadDeviceSystemTypeFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'tadGeometricXFilter',
        label: 'label.sith.tpm.sithMesTpmAxisDataTad.filter.tadGeometricX',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tadGeometricYFilter',
        label: 'label.sith.tpm.sithMesTpmAxisDataTad.filter.tadGeometricY',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tadGeometricZFilter',
        label: 'label.sith.tpm.sithMesTpmAxisDataTad.filter.tadGeometricZ',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tadGeometricAFilter',
        label: 'label.sith.tpm.sithMesTpmAxisDataTad.filter.tadGeometricA',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tadMachineXFilter',
        label: 'label.sith.tpm.sithMesTpmAxisDataTad.filter.tadMachineX',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tadMachineYFilter',
        label: 'label.sith.tpm.sithMesTpmAxisDataTad.filter.tadMachineY',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tadMachineZFilter',
        label: 'label.sith.tpm.sithMesTpmAxisDataTad.filter.tadMachineZ',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tadMachineAFilter',
        label: 'label.sith.tpm.sithMesTpmAxisDataTad.filter.tadMachineA',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tadLoadXFilter',
        label: 'label.sith.tpm.sithMesTpmAxisDataTad.filter.tadLoadX',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tadLoadYFilter',
        label: 'label.sith.tpm.sithMesTpmAxisDataTad.filter.tadLoadY',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tadLoadZFilter',
        label: 'label.sith.tpm.sithMesTpmAxisDataTad.filter.tadLoadZ',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tadLoadAFilter',
        label: 'label.sith.tpm.sithMesTpmAxisDataTad.filter.tadLoadA',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tadExceptionDescFilter',
        label: 'label.sith.tpm.sithMesTpmAxisDataTad.filter.tadExceptionDesc',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tadStartTimeRteFilter',
        label: 'label.sith.tpm.sithMesTpmAxisDataTad.filter.tadStartTimeRte',
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tadStartTimeLteFilter',
        label: 'label.sith.tpm.sithMesTpmAxisDataTad.filter.tadStartTimeLte',
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tadEndTimeRteFilter',
        label: 'label.sith.tpm.sithMesTpmAxisDataTad.filter.tadEndTimeRte',
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tadEndTimeLteFilter',
        label: 'label.sith.tpm.sithMesTpmAxisDataTad.filter.tadEndTimeLte',
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tadDeviceCodeFilter',
        label: 'label.sith.tpm.sithMesTpmAxisDataTad.filter.tadDeviceCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tadDeviceSystemTypeFilter',
        label: 'label.sith.tpm.sithMesTpmAxisDataTad.filter.tadDeviceSystemType',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'tadGeometricX',
        label: 'label.sith.tpm.sithMesTpmAxisDataTad.entity.tadGeometricX',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tadGeometricY',
        label: 'label.sith.tpm.sithMesTpmAxisDataTad.entity.tadGeometricY',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tadGeometricZ',
        label: 'label.sith.tpm.sithMesTpmAxisDataTad.entity.tadGeometricZ',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tadGeometricA',
        label: 'label.sith.tpm.sithMesTpmAxisDataTad.entity.tadGeometricA',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tadMachineX',
        label: 'label.sith.tpm.sithMesTpmAxisDataTad.entity.tadMachineX',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tadMachineY',
        label: 'label.sith.tpm.sithMesTpmAxisDataTad.entity.tadMachineY',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tadMachineZ',
        label: 'label.sith.tpm.sithMesTpmAxisDataTad.entity.tadMachineZ',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tadMachineA',
        label: 'label.sith.tpm.sithMesTpmAxisDataTad.entity.tadMachineA',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tadLoadX',
        label: 'label.sith.tpm.sithMesTpmAxisDataTad.entity.tadLoadX',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tadLoadY',
        label: 'label.sith.tpm.sithMesTpmAxisDataTad.entity.tadLoadY',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tadLoadZ',
        label: 'label.sith.tpm.sithMesTpmAxisDataTad.entity.tadLoadZ',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tadLoadA',
        label: 'label.sith.tpm.sithMesTpmAxisDataTad.entity.tadLoadA',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tadExceptionDesc',
        label: 'label.sith.tpm.sithMesTpmAxisDataTad.entity.tadExceptionDesc',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tadStartTime',
        label: 'label.sith.tpm.sithMesTpmAxisDataTad.entity.tadStartTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tadEndTime',
        label: 'label.sith.tpm.sithMesTpmAxisDataTad.entity.tadEndTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tadDeviceCode',
        label: 'label.sith.tpm.sithMesTpmAxisDataTad.entity.tadDeviceCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tadDeviceSystemType',
        label: 'label.sith.tpm.sithMesTpmAxisDataTad.entity.tadDeviceSystemType',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.tpm.sithMesTpmAxisDataTad.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        }
]

export {SithMesTpmAxisDataTad, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
